export interface Theme {
  primary: string;
  secondary: string;
}

export default {
  primary: '#fb251b',
  secondary: '#9093c3'
};
